import { toggleMeMode } from './memode'
import { showCommonMessage, showVideoPopup } from './popup'
import { crashCourse, primerVideos } from './help_crash_course'
import { purgeAjax } from './purge'

function App() {
  //const window = this;
  const document = window.document;
  const docReady = (/p/).test(document.readyState);
  var initCalled = false;
  var rabbitloader_local_vars = window.rabbitloader_local_vars;
  //use these variables so compression is better when code is minified
  var getAttribute = "getAttribute";
  var localStorage = "localStorage";
  let PREVENT_DEFAULT = "preventDefault";

  var click = 'click';
  var jQuery = window.jQuery;
  let rabbitloader_ajax_prefix = "rabbitloader_ajax_";

  function setUpListeners() {
    showScore('score_circle_best');
    showScore('warming_progress_bar');
    jQuery('.rabbitloader_purge_page').on(click, purgeAjax);
    jQuery('#rabbitloader_purge_all').on(click, purgeAjax);
    window.setTimeout(rlCron, 1000); //immediately after page is loaded
    window.setInterval(rlCron, getRndInteger(300, 600) * 1000);//every 300 to 600 seconds
    jQuery(document).on(click, '.tpopup', showTooltip);
    jQuery(document).on('change', '#rl_chk_public', handleChkPublic);
    //jQuery(document).on('click', '#rl_show_survey', showSurvey);
    jQuery(document).on('click', '#rl_me_learn_more', function () { showVideoPopup('ol4nuYuYTeM') });
    onPluginDeactivate();
    crashCourse();
    primerVideos();
  }

  function showScore(elid) {
    var el = document.getElementById(elid);
    if (!el) {
      return;
    }
    var options = {
      percent: el[getAttribute]('data-percent') || 15,
      size: el[getAttribute]('data-size') || 150,
      lineWidth: el[getAttribute]('data-line') || 10,
      rotate: el[getAttribute]('data-rotate') || 0,
      ocolor: el[getAttribute]('data-ocolor') || '#f0fff7',
      icolor: el[getAttribute]('data-icolor') || '#0cce6b',
      fsize: el[getAttribute]('data-fsize') || '60px'
    }

    var canvas = document.createElement('canvas');
    var span = document.createElement('span');
    span.textContent = options.percent;
    span.style.lineHeight = options.size + 'px';
    span.style.width = options.size + 'px';
    span.style.fontSize = options.fsize;
    span.style.color = options.icolor;

    if (typeof (G_vmlCanvasManager) !== 'undefined') {
      G_vmlCanvasManager.initElement(canvas);
    }

    var ctx = canvas.getContext('2d');
    canvas.width = canvas.height = options.size;

    el.style.width = options.size + 'px';
    el.style.height = options.size + 'px';
    el.appendChild(span);
    el.appendChild(canvas);

    ctx.translate(options.size / 2, options.size / 2); // change center
    ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

    //imd = ctx.getImageData(0, 0, 240, 240);
    var radius = (options.size - options.lineWidth) / 2;

    var drawCircle = function (color, lineWidth, percent) {
      percent = Math.min(Math.max(0, percent || 1), 1);
      ctx.beginPath();
      ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
      ctx.strokeStyle = color;
      ctx.lineCap = 'round'; // butt, round or square
      ctx.lineWidth = lineWidth
      ctx.stroke();
    };

    options.percent = parseFloat(options.percent); //display text may contain % etc
    drawCircle(options.ocolor, options.lineWidth, 100 / 100);
    drawCircle(options.icolor, options.lineWidth, options.percent / 100);
  }

  //this function calls the admin_ajax to execute few periodic functions calls in PHP, as long as the admin page is open, the ajax will be called almost every minute 
  function rlCron() {
    let ajax_action = rabbitloader_ajax_prefix + "cron";//v
    //apply lock to ensure if admin page is loaded in multiple tabs, we do not consume lots of resources
    let lastRunTime = window[localStorage].getItem(ajax_action);
    let now = Date.now();
    if (lastRunTime) {
      let diff = now - new Date(lastRunTime)
      let diffInSeconds = diff / 1000;
      if (diffInSeconds < 180) {
        //this tab or some tab called in this ajax in last 180 seconds, lets exit and wait for next timer call
        return;
      }
    } else {
      //possibly first run
    }
    window[localStorage].setItem(ajax_action, now);

    const formData = new FormData();
    formData.append('action', ajax_action);
    formData.append('rl_nonce', rabbitloader_local_vars.rl_nonce);
    fetch(rabbitloader_local_vars.admin_ajax, {
      'method': 'POST',
      'body': formData
    });
  }

  function showTooltip(e) {
    let title = jQuery(e.target).attr('title-html');
    if (!title) {
      title = jQuery(e.target).attr('title');
    }
    if (title) {
      showCommonMessage(title);
    }
  }

  function handleChkPublic(e) {
    let private_mode = !jQuery(e.target).is(':checked');
    showCommonMessage('Updating...');//show progress till API call completes
    toggleMeMode('', private_mode, function () { });
  }

  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function onPluginDeactivate() {
    let slug = `rabbit-loader`;
    let deactivateLink = `tr[data-slug="${slug}"] #deactivate-${slug}`;
    //private_mode_val
    if (jQuery(deactivateLink).length == 0) {
      //not on the plugins page
      return;
    }
    let deactivateLinkUrl = jQuery(deactivateLink).attr('href');
    let popup_id = `${slug}-me-mode-popup`
    let btn_enable_memode = `${slug}-en`
    let btn_deactivate = `${slug}-de`
    let popup_html = `<div id="${popup_id}" style="display: none; position: absolute; white-space: normal; max-width: 350px; width: 350px; background: #fcf9e8; z-index: 10001; border: 4px solid #dba617; box-shadow: rgba(0, 0, 0, 0.6) 0px 0px 30px 0px; left: -10px; text-align: center; padding:20px;"><p class="">${rl_de_popup.pop_msg}</p><div style="margin-top:25px;"><a id="${btn_deactivate}" class="button button-secondary alignleft" href="#">${rl_de_popup.btn_de}</a><button id="${btn_enable_memode}" class="button button-primary alignright">${rl_de_popup.btn_en}</button></div></div>`;

    jQuery(deactivateLink).parent().append(popup_html);
    jQuery(deactivateLink).on(click, function (e) {
      e[PREVENT_DEFAULT]();
      jQuery('#' + popup_id).show();
      let ref1 = jQuery(window).scrollTop() + jQuery(window).height();
      let ref2 = jQuery('#' + popup_id).offset().top + jQuery('#' + popup_id).outerHeight(true);
      if (ref2 > ref1) {
        jQuery('html,body').animate({ scrollTop: jQuery('#' + popup_id).offset().top - (jQuery(window).height() - jQuery('#' + popup_id).outerHeight(true) - 10) }, 200);
      }
      jQuery(`#${btn_deactivate}`).attr('href', deactivateLinkUrl);
    });


    jQuery(`#${btn_enable_memode}`).on(click, function (e) {
      e[PREVENT_DEFAULT]();
      e.stopPropagation();
      jQuery(deactivateLink).unbind(click);

      toggleMeMode(btn_enable_memode, true, function (done) {
        if (done) {
          jQuery('#' + popup_id).hide();
        }
      });
    });
  }

  //survey removed on >= v2.19.17
  // function showSurvey() {
  //   let form = '<iframe src="https://forms.zohopublic.in/abhishek33/form/InstallFeedback/formperma/DxCLomfqe7Jf8kYJR7YVxKMK7EQu-0bPwXlIrrapHMg" width="100%" height="600px"></iframe>'
  //   showCommonMessage(form, true);

  //   //mark the form shown, so it will not be shown again
  //   const formData = new FormData();
  //   //rabbitloader_ajax_survey_dismissed
  //   formData.append('action', rabbitloader_ajax_prefix + 'survey_dismissed');
  //   formData.append('rl_nonce', rabbitloader_local_vars.rl_nonce);

  //   fetch(rabbitloader_local_vars.admin_ajax, {
  //     'method': 'POST',
  //     'body': formData
  //   });
  // }

  function init() {
    if (initCalled) { return; }
    initCalled = true;
    setUpListeners();
  }
  docReady ? init() : window.addEventListener('load', init);
}

export default App;